module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-right-11a25cca298db43acd1a9112d852cda8.svg";